export const compose =
  (...fns) =>
  (result) => {
    const list = [...fns];

    while (list.length) {
      result = list.pop()(result);
    }

    return result;
  };

export default {
  compose,
};
